import { createMemo } from "solid-js"
import getTileGraphNodeLayerTerrain1Entity from "../../lib/core/entity/EntityLayerId/getTileGraphNodeLayerTerrain1Entity"
import isNotNil from "../../lib/ldsh/isNotNil"
import isNumberListSame from "../signal/equals/isNumberListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { createSharedTileGraphNodeCollectionMemo } from "./createSharedTileGraphNodeCollectionMemo"

// return all layer 1 terrain ents
export const useSharedTerrainLayer1EntityTypeIdOrZeroArrayMemo = createSharedCachedFactory((engine) => {
  const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)

  const getTerrainLayer1EntityTypeIdOrZeroArray = createMemo<Int8Array>(() => {
    const tpNodeList = getTileGraphNodesList()
    const len = tpNodeList.length
    // will be filled with 0s by default
    const list = new Int8Array(len)
    for (let index = 0; index < len; index++) {
      const tpNode = tpNodeList[index]
      const ent = getTileGraphNodeLayerTerrain1Entity(tpNode)
      if (isNotNil(ent)) {
        list[index] = ent.etype_id
      }
    }
    return list
  }, new Int8Array(), {
    equals: isNumberListSame,
  })

  // createEffect(() => {
  //   console.log('TerrainLayer1EntsLis', getTerrainLayer1EntityTypeIdOrZeroArray())
  // })

  return getTerrainLayer1EntityTypeIdOrZeroArray
})